
 
<template>
  <b-row>
    <!-- people group 1 -->
    <b-col md="6">
      <b-card>
        <h3>كل الأسئلة</h3>
        <hr />
        <!-- draggable -->
        <draggable
          :list="questions"
          tag="ul"
          group="people"
          class="list-group list-group-flush cursor-move"
        >
          <b-list-group-item
            v-for="(listItem, index) in questions"
            :key="index"
            tag="li"
          >
            <div class="d-flex x justify-content-between align-items-center">
              <div class="media">
              <b-avatar :text="listItem.question.slice(0, 2)" />
              <div class="ml-25">
                <b-card-text class="mb-0 font-weight-bold">
                  {{ listItem.question }}
                </b-card-text>
                <small>{{ listItem.type }}</small>
              </div>
              </div>
            <div class="font-weight-bolder text-danger float-left"> -$23 </div>
            </div>
          </b-list-group-item>
        </draggable>
      </b-card>
    </b-col>

    <!-- people group 2 -->
    <b-col md="6" class="mt-sm-2 mt-md-0">
      <b-card>
        <h3>أسئلة مختارة</h3>
        <hr />
        <!-- draggable -->
        <draggable
          :list="examsQuestions"
          tag="ul"
          group="people"
          class="list-group list-group-flush cursor-move"
        >
          <b-list-group-item
            v-for="(listItem, index) in examsQuestions"
            :key="index"
            tag="li"
          >
            <div class="d-flex">
              <b-avatar :text="listItem.question.slice(0, 2)" />
              <div class="ml-25">
                <b-card-text class="mb-0 font-weight-bold">
                  {{ listItem.question }}
                </b-card-text>
                <small>{{ listItem.type }}</small>
              </div>
            </div>
          </b-list-group-item>
        </draggable>
        <hr />
        <b-btn block variant="primary" @click="save()">
          <i class="fa fa-plus" /> {{ $t("site.save") }}</b-btn
        >
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BListGroupItem, BAvatar } from "bootstrap-vue";
import draggable from "vuedraggable";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import QuestionsController from "@/Controllers/QuestionsController";
import ExamsController from "@/Controllers/ExamsController";

export default {
  components: {
    draggable,
    BListGroupItem,
    BAvatar,
    Prism,
  },
  data() {
    return {
      examsQuestions: [],
      questions: [],
    };
  },
  async created() {
    //
    this.examsQuestions = await new ExamsController().getQuestions(
      this.$route.params.id
    );
    // this.$router.parem.
    let questions = await new QuestionsController().CourseQuestions(
      this.$route.params.courseId
    );
    this.questions = questions.filter((question) => {
      let index = this.examsQuestions.findIndex((ex) => ex.id == question.id);
      return index == -1;
    });
  },
  methods: {
    async save() {
      let ids = this.examsQuestions.map((a) => a.id);
      let ret = await new ExamsController().addNewQuestion({
        examId: this.$route.params.id,
        ids: ids,
      });
      if (ret) {
        this.$router.push({ name: "Exams" });
      }
    },
  },
};
</script>

<style>
.list-group-item {
  transition: all 1s;
}
</style>